import { IApiResponse, ISearchResponse } from '../../../common/models/common';
import request from '../../../utils/request';
import {
  ISearchSlim360O365UserCopilotActivitySummary,
  ISlim360O365UserCopilotActivitySummary,
} from './o365UserCopilotActivitySummary.model';

class Slim360O365UserCopilotActivitySummaryService {
  ENDPOINT = '/slim360-o365-user-copilot-activity-summary';

  public async searchSlim360O365UserCopilotActivitySummary(
    searchParams?: ISearchSlim360O365UserCopilotActivitySummary
  ): Promise<IApiResponse<ISearchResponse<ISlim360O365UserCopilotActivitySummary>>> {
    const url = `${this.ENDPOINT}/search`;
    return request({ url, method: 'POST', data: searchParams }).then((res) => {
      return res.data;
    });
  }

  public async getSlim360O365UserCopilotActivitySummaryById(id: number): Promise<any> {
    const url = `${this.ENDPOINT}/${id}`;
    return request({ url, method: 'GET' }).then((res) => {
      return res.data;
    });
  }

  public async saveSlim360O365UserCopilotActivitySummary(
    data: ISlim360O365UserCopilotActivitySummary
  ): Promise<any> {
    const { id, ...restData } = data;
    if (id > 0) {
      const url = `${this.ENDPOINT}/${id}`;
      return request({ url, method: 'PUT', data: restData }).then((res) => {
        return res.data;
      });
    } else {
      const url = `${this.ENDPOINT}`;
      return request({ url, method: 'POST', data: restData }).then((res) => {
        return res.data;
      });
    }
  }

  public async deleteSlim360O365UserCopilotActivitySummary(id: number): Promise<any> {
    const url = `${this.ENDPOINT}/${id}`;
    return request({ url, method: 'DELETE' }).then((res) => {
      return res.data;
    });
  }

  public async exportExcelFile(
    searchParams?: ISearchSlim360O365UserCopilotActivitySummary
  ): Promise<any> {
    const url = `back-ground-processes/export-excel`;
    return request({
      url,
      method: 'POST',
      data: searchParams,
    }).then((res) => {
      return res;
    });
  }
}
export default new Slim360O365UserCopilotActivitySummaryService();
